// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"127":"gamelist","465":"crosscase"}[chunkId] || chunkId) + "-legacy." + {"127":"0404d5d6","465":"b3ecebca","471":"86b4faa2","584":"339ca57e"}[chunkId] + ".js";
};